/** @typedef {'open_street_imagery'|'wms'|'wmts'|'google_maps'} MapBaseType */

/**
 * @typedef {object} MapBase
 * @property {string} key - The unique key identifier for the map base.
 * @property {string} name - The name of the map base.
 * @property {string} [url] - The URL template for the map tiles (required for open_street_imagery and wms).
 * @property {MapBaseType} type - The type of the map base
 * @property {string} [image_format] - Optional image format for WMS layers (e.g., 'image/png').
 * @property {string} [mapType] - Google Maps map type (roadmap, satellite, terrain, hybrid).
 */

// TODO (06/25/2026): Remove this once wms-layers is de-coupled from katapult-maps-desktop
/**
 * Builds the mapTypeIds key that wms-layers derives from a map base name.
 * @param {string} name
 * @returns {string}
 */
export function getLegacyMapTypeId(name) {
  return 'wms:' + name.toLowerCase().replace(' ', '_');
}

/** The key of the map base that loads automatically on a cold start. */
export const DEFAULT_CESIUM_MAP_BASE_KEY = 'open_street_map_standard';

// Provide a back door for ongoing map engine development.
const _cesiumMapDev = typeof localStorage !== 'undefined' && localStorage.getItem('_cesium_map_dev') === 'true';
const allowGoogleMapBases = _cesiumMapDev;

/** @type Record<string, MapBase> */
const GOOGLE_MAP_BASES = {
  google_satellite: {
    key: 'google_satellite',
    name: 'Google Satellite',
    type: 'google_maps',
    mapType: 'satellite'
  },
  google_hybrid: {
    key: 'google_hybrid',
    name: 'Google Hybrid',
    type: 'google_maps',
    mapType: 'hybrid'
  },
  google_roadmap: {
    key: 'google_roadmap',
    name: 'Google Roadmap',
    type: 'google_maps',
    mapType: 'roadmap'
  },
  google_terrain: {
    key: 'google_terrain',
    name: 'Google Terrain',
    type: 'google_maps',
    mapType: 'terrain'
  }
};

/** @type Record<string, MapBase> */
export const DEFAULT_CESIUM_MAP_BASES = {
  ...(allowGoogleMapBases ? GOOGLE_MAP_BASES : {}),
  open_street_map_standard: {
    key: 'open_street_map_standard',
    name: 'OpenStreetMap',
    url: 'https://tile.openstreetmap.org/',
    type: 'open_street_imagery'
  }
};
